/* SURVIVAL CODEX — small brand enhancements. No dependencies. */
(function () {
  'use strict';

  /* 1. Wordmark lockup: "Survival Codex" -> — SURVIVAL CODEX — (thin/bold split) */
  function wordmark() {
    document.querySelectorAll('.header__heading-link .h2, .header__heading .h2, a.header__heading-link').forEach(function (el) {
      if (el.querySelector('.codex-wordmark')) return;
      if (!/survival\s*codex/i.test(el.textContent || '')) return;
      el.innerHTML =
        '<span class="codex-wordmark">' +
        '<span class="wm-dash">&#8212;</span>' +
        '<span class="wm-thin">SURVIVAL</span>&nbsp;<span class="wm-bold">CODEX</span>' +
        '<span class="wm-dash">&#8212;</span>' +
        '</span>';
    });
  }

  /* 2. Header pre-order CTA (desktop) */
  function headerCta() {
    var icons = document.querySelector('.header .header__icons');
    if (!icons || document.querySelector('.codex-header-cta')) return;
    var a = document.createElement('a');
    /* 2026-10-27: on the product page the link reloaded the same page and looked like
       "it loads and nothing happens" (Nicolas). Where the buy box is on the page, this button
       presses the buy box's own pre-order button, so it keeps whatever extras are ticked. */
    var buyAnchor = document.getElementById('Codex-Buy');
    a.href = buyAnchor ? '#Codex-Buy' : '/products/survival-codex';
    if (buyAnchor) {
      a.addEventListener('click', function (e) {
        var buyBtn = buyAnchor.querySelector('button.buy-btn');
        if (!buyBtn || buyBtn.disabled) return;
        e.preventDefault();
        buyBtn.click();
      });
    }
    a.className = 'codex-btn codex-btn--primary codex-btn--small codex-header-cta';
    /* 2026-08-26 (dieter): the label used to hardcode "$289", which is wrong in every
       market except the US — this store has six enabled markets across five currencies,
       so a DKK visitor saw "$289" in the header beside a "1.891 kr" buy button. Read the
       real, already-localised price out of the page when one is present; otherwise say
       nothing about price. Never reintroduce a currency figure here: this runs in JS and
       has no access to Liquid's money filter. */
    var buyBox = document.querySelector('[data-codex-price]');
    var priceTxt = buyBox ? (buyBox.getAttribute('data-codex-price') || '').trim() : '';
    a.textContent = priceTxt ? 'Pre-order ' + priceTxt : 'Pre-order';
    icons.appendChild(a);
  }

  /* 3. Reveal-on-scroll */
  function reveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.codex-reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, {
      // was -8%, which held an element back until it was already 8% of the viewport
      // INSIDE the fold; on a fast scroll that read as a blank screen waiting to fill.
      // A positive bottom margin grows the observed box downward instead, so a section
      // starts fading while it is still below the fold and has arrived by the time it
      // is properly on screen.
      rootMargin: '0px 0px 14% 0px'
    });
    document.querySelectorAll('.codex-reveal').forEach(function (el) { io.observe(el); });
  }


  /* 4. Footer serial line */
  function serial() {
    var bottom = document.querySelector('.footer__content-bottom .footer__copyright, .footer__copyright');
    if (!bottom || document.querySelector('.codex-footer-serial')) return;
    var d = document.createElement('div');
    d.className = 'codex-footer-serial';
    /* 2026-08-26 (dieter): was a hardcoded "2027", one year ahead of Shopify's own
       auto-generated copyright line directly above it, and named Better Objects here
       too. Computed from the visitor's clock so it can never drift again. */
    d.textContent = 'SURVIVAL CODEX \u00B7 SC-01 \u00B7 \u00A9 ' + new Date().getFullYear();
    bottom.appendChild(d);
  }

  function init() { wordmark(); headerCta(); reveal(); serial(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Lazy background images (2026-10-04, page speed). Sections below the fold carry data-bg (and data-bg-sm, a
   phone-sized copy, under 750px) instead of an inline background-image, so their images no longer download
   at page start and compete with the first screen. Each one loads when it comes within ~800px of the screen.
   In the theme editor everything loads at once, and a section the editor re-renders is filled again. */
(function () {
  var small = window.matchMedia('(max-width: 749px)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  function show(el) {
    var url = (small && el.getAttribute('data-bg-sm')) || el.getAttribute('data-bg');
    el.style.backgroundImage = "url('" + url + "')";
    el.removeAttribute('data-bg');
  }
  var io = (!editor && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); show(e.target); } });
  }, { rootMargin: '800px' }) : null;
  function scan(root) {
    root.querySelectorAll('[data-bg]').forEach(function (el) { if (io) io.observe(el); else show(el); });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* Deferred gallery slides (2026-10-04, page speed). Slides 2+ of the product gallery hold their sources in
   data-src / data-srcset; fill them in once the page has loaded, or straight away on the first swipe.
   A gallery the theme editor re-renders is filled at once. */
(function () {
  function fillIn(root) {
    root.querySelectorAll('img[data-gal-defer]').forEach(function (img) {
      var pic = img.parentNode;
      pic.querySelectorAll('source[data-srcset]').forEach(function (s) { s.srcset = s.getAttribute('data-srcset'); s.removeAttribute('data-srcset'); });
      if (img.getAttribute('data-srcset')) { img.srcset = img.getAttribute('data-srcset'); img.removeAttribute('data-srcset'); }
      img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); img.removeAttribute('data-gal-defer');
    });
  }
  document.addEventListener('shopify:section:load', function (e) { fillIn(e.target); });
  if (!document.querySelector('img[data-gal-defer]')) return;
  var done = false;
  function fill() { if (done) return; done = true; fillIn(document); }
  var rail = document.querySelector('[data-gal-rail]');
  if (rail) ['scroll', 'touchstart', 'pointerdown'].forEach(function (ev) { rail.addEventListener(ev, fill, { passive: true, once: true }); });
  document.querySelectorAll('[data-gal-to]').forEach(function (b) { b.addEventListener('click', fill, { once: true }); });
  if (document.readyState === 'complete') setTimeout(fill, 0); else window.addEventListener('load', function () { setTimeout(fill, 0); });
})();
